const state = {
  infoStore:
    [
      {
        id: 1,
        title: "Vue.js",
        version: "3.5.13",
        url: "https://v3.ru.vuejs.org"
      },
      {
        id: 2,
        title: "Vue Router",
        version: "4.5.0",
        url: "https://router.vuejs.org"
      },
      {
        id: 3,
        title: "VueX",
        version: "4.1.0",
        url: "https://vuex.vuejs.org"
      },
      {
        id: 4,
        title: "Webpack",
        version: "5.97.1",
        url: "https://webpack.js.org"
      },
      {
        id: 5,
        title: "Vue I18n",
        version: "9.9.1",
        url: "https://vue-i18n.intlify.dev"
      },
      {
        id: 6,
        title: "Three.js",
        version: "171",
        url: "https://github.com/mrdoob/three.js/releases"
      },
      {
        id: 7,
        title: "Orbit controls",
        version: "82.1.0",
        url: "https://threejs.org/docs/#examples/en/controls/OrbitControls"
      },
      {
        id: 8,
        title: "Axios",
        version: "1.12.2",
        url: "https://github.com/axios/axios"
      },
      {
        id: 9,
        title: "jsPDF",
        version: "3.0.1",
        url: "https://www.npmjs.com/package/jspdf"
      },
      {
        id: 10,
        title: "HTML5",
        version: "",
        url: "https://developer.mozilla.org/ru/docs/Learn/HTML/Introduction_to_HTML"
      },
      {
        id: 11,
        title: "CSS3",
        version: "",
        url: "https://developer.mozilla.org/ru/docs/Learn/CSS/First_steps"
      },
      {
        id: 12,
        title: "SASS",
        version: "1.92.1",
        url: "https://sass-lang.com"
      },
      {
        id: 13,
        title: "FlexBox CSS",
        version: "",
        url: "https://developer.mozilla.org/ru/docs/Learn/CSS/CSS_layout/Flexbox"
      },
      {
        id: 14,
        title: "Grid CSS",
        version: "",
        url: "https://developer.mozilla.org/ru/docs/Web/CSS/CSS_Grid_Layout"
      },
      {
        id: 15,
        title: "JavaScript",
        version: "",
        url: "https://developer.mozilla.org/ru/docs/Learn/JavaScript"
      },
      {
        id: 16,
        title: "TypeScript",
        version: "5.7.2",
        url: "https://www.typescriptlang.org/"
      },
      {
        id: 17,
        title: "Markdown",
        version: "",
        url: "https://www.markdownguide.org"
      },
      {
        id: 18,
        title: "OpenWeather Map API",
        version: "",
        url: "https://openweathermap.org"
      },
      {
        id: 19,
        title: "CoinGecko API",
        version: "",
        url: "https://www.coingecko.com"
      },
      {
        id: 20,
        title: "NBU API",
        version: "",
        url: "https://bank.gov.ua/ua/open-data/api-dev"
      },
      {
        id: 21,
        title: "Lorem Picsum API",
        version: "",
        url: "https://picsum.photos"
      },
      {
        id: 22,
        title: "Pixabay API",
        version: "",
        url: "https://pixabay.com"
      },
      {
        id: 23,
        title: "Google Search Console",
        version: "",
        url: "https://search.google.com/search-console"
      },
      {
        id: 24,
        title: "Google Analytics",
        version: "4.0",
        url: "https://analytics.google.com"
      },
      {
        id: 25,
        title: "Open Graph protocol",
        version: "",
        url: "https://ogp.me"
      },
      {
        id: 26,
        title: "Favicon",
        version: "",
        url: "https://developer.mozilla.org/en-US/docs/Glossary/Favicon"
      },
      {
        id: 27,
        title: "Sitemap",
        version: "",
        url: "https://www.sitemaps.org"
      },
      {
        id: 28,
        title: "Robots.txt",
        version: "",
        url: "https://developers.google.com/search/docs/crawling-indexing/robots/intro"
      },
    ]
};
const getters = {};
const mutations = {};
const actions = {};
export default {
  state,
  getters,
  mutations,
  actions
};